﻿// generic entry point used by layouts if the view doesn't provide
// it's own entry point.

// does nothing other than ensure that webpack has an entry point
// file ...

